import React from "react"
import { Helmet } from "react-helmet"

const StructuredData = ({ type, data }) => {
  const generateSchema = () => {
    const baseSchema = {
      "@context": "https://schema.org",
    }

    switch (type) {
      case "organization":
        return {
          ...baseSchema,
          "@type": "Organization",
          name: "ArtCollection.io",
          url: "https://www.artcollection.io",
          logo: "https://artcollection-io.s3-us-west-1.amazonaws.com/web/og.png",
          sameAs: [
            "https://twitter.com/artcollectionio",
            "https://www.facebook.com/artcollection.io",
          ],
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer service",
            availableLanguage: "English",
          },
        }

      case "website":
        return {
          ...baseSchema,
          "@type": "WebSite",
          name: "ArtCollection.io",
          url: "https://www.artcollection.io",
          potentialAction: {
            "@type": "SearchAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "https://www.artcollection.io/search?q={search_term_string}",
            },
            "query-input": "required name=search_term_string",
          },
        }

      case "service":
        return {
          ...baseSchema,
          "@type": "Service",
          name: "Art Collection Management Platform",
          provider: {
            "@type": "Organization",
            name: "ArtCollection.io",
          },
          serviceType: "Art Collection Management Software",
          description: "Cloud-based platform for organizing, tracking, and managing art collections for galleries, artists, and collectors",
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
            eligibleRegion: {
              "@type": "Place",
              name: "Worldwide",
            },
          },
          areaServed: {
            "@type": "Place",
            name: "Worldwide",
          },
          hasOfferCatalog: {
            "@type": "OfferCatalog",
            name: "Art Collection Services",
            itemListElement: [
              {
                "@type": "Service",
                name: "Inventory Management",
                description: "Track and organize your entire art collection",
              },
              {
                "@type": "Service",
                name: "Auction Results Database",
                description: "Access comprehensive auction results and market analytics",
              },
              {
                "@type": "Service",
                name: "Art Market Alerts",
                description: "Stay informed with real-time market updates",
              },
              {
                "@type": "Service",
                name: "Financial Reporting",
                description: "Generate detailed financial reports for your collection",
              },
            ],
          },
        }

      case "faq":
        return {
          ...baseSchema,
          "@type": "FAQPage",
          mainEntity: data?.questions?.map(q => ({
            "@type": "Question",
            name: q.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: q.answer,
            },
          })) || [],
        }

      case "breadcrumb":
        return {
          ...baseSchema,
          "@type": "BreadcrumbList",
          itemListElement: data?.items?.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            item: item.url,
          })) || [],
        }

      case "softwareApplication":
        return {
          ...baseSchema,
          "@type": "SoftwareApplication",
          name: "ArtCollection.io",
          operatingSystem: "iOS, Android, Web",
          applicationCategory: "BusinessApplication",
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4.8",
            ratingCount: "250",
          },
        }

      default:
        return null
    }
  }

  const schema = generateSchema()

  if (!schema) return null

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  )
}

export default StructuredData